import React from 'react';


const OverlayContext = React.createContext({ });

export const OverlayContextProvider = ({ newTaskTemplate = {}, hideAdd, children }) => (
  <OverlayContext.Provider value={{ newTaskTemplate, hideAdd }}>
    { children }
  </OverlayContext.Provider>
);

export default OverlayContext;
